module.exports = __webpack_public_path__ + "assets/2@2x.c8970a3a.png";